import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SmallBrandsList from "@components/Features/PostAdv/SmallBrandsList/SmallBrandsList";
import { useGetModelsOptionsQuery } from "@app/store/filtersOptionsApi";
import { AppState } from "@app/store/store";
import { Model } from "@app/store/types";
import { getActions } from "../../../../utils/utils";
import MaterialTextInput from "../../../UI/Buttons/MaterialTextInput/MaterialTextInput";
import { ModelSelectorProps } from "./types";
import classes from "./ModelSelector.module.scss";

const ModelSelector = ({ showModelSelector, storeName = "postForm" }: ModelSelectorProps) => {
    const isEditing = storeName === "editForm";
    const actions = getActions(storeName);

    const selectedBrand = useSelector((state: AppState) => state[storeName].selectedBrand);
    const selectedModel = useSelector((state: AppState) => state[storeName].selectedModel);

    const [modelValue, setModelValue] = useState("");
    useEffect(() => {
        if (selectedModel) {
            setModelValue(selectedModel.name);
        } else {
            setModelValue("");
        }
    }, [selectedModel]);

    const dispatch = useDispatch();
    const { data: modelOptions, isFetching: modelOptionsIsFetching } = useGetModelsOptionsQuery(
        {
            brandUuid: selectedBrand?.id || ""
        },
        {
            skip: !selectedBrand?.id
        }
    );

    const filteredModelOptions =
        modelOptions && modelValue
            ? modelOptions.filter((model: Model) =>
                  model.name.toLowerCase().includes(modelValue.toLowerCase())
              )
            : modelOptions || [];

    const selectModel = (model?: Model) => {
        if (isEditing) {
            dispatch(actions.setGeneration(""));
            dispatch(actions.setModel(model));
        } else {
            dispatch(
                actions.setGeneration({
                    val: "",
                    setUpdated: false
                })
            );

            dispatch(actions.setModel(model));
        }
        setModelValue(model ? model.name : "");
    };

    return (
        <div className={classes.ModelSelector}>
            {selectedBrand && (
                <MaterialTextInput
                    value={modelValue}
                    onChange={(val) => {
                        setModelValue(val);

                        if (val === "") {
                            selectModel(undefined);
                        }
                    }}
                    label="Модель авто"
                />
            )}

            {showModelSelector && (
                <>
                    {modelOptions?.length === 0 && (
                        <div className={classes.NoResults}>
                            <span>
                                В нашей базе не таких моделей,{" "}
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        alert(
                                            "тут нужно уточнить, даем ли возможность создавать модели?"
                                        );
                                    }}
                                    href=""
                                >
                                    создать модель?
                                </a>
                            </span>
                            <br />
                            <br />
                            <br />
                        </div>
                    )}
                    <SmallBrandsList
                        brands={filteredModelOptions || []}
                        onChanged={(item) => {
                            selectModel(item);
                        }}
                        isLoading={modelOptionsIsFetching}
                        expandLabel="Показать все модели"
                    />
                </>
            )}
        </div>
    );
};
export default ModelSelector;